import { render } from "./ListeTypeDemande.vue?vue&type=template&id=0981969f&ts=true"
import script from "./ListeTypeDemande.vue?vue&type=script&lang=ts"
export * from "./ListeTypeDemande.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__